module.exports = __webpack_public_path__ + "img/sec_car3.caf61250.jpg";